import { userContentDetailsService } from '@/data/services/content/user-content-details-service'
import { userEnrollmentContentInfoService } from '@/data/services/content/user-enrollment-content-info-service'
import { FeatureFlagName, getFlagValue } from '@/infra/feature-flag'
import { contentDetailsPromise, enrollmentContentInfoPromise } from '@/main/routes/helpers/loaders'
import { queryClient } from '@/infra/http'

/**
 * Loads content details and enrollment info for a specific content
 * Uses different data sources based on PRODUCT_FIELD_MIGRATION feature flag
 */
export async function loadContentDetails(contentId: number) {
  const isProductFieldMigrationEnabled = getFlagValue(FeatureFlagName.PRODUCT_FIELD_MIGRATION)

  const requestContentDetailsPromise = isProductFieldMigrationEnabled
    ? userContentDetailsService.fetchQueryUserContentDetails(contentId)
    : contentDetailsPromise(queryClient, contentId)

  const requestEnrollmentContentInfoPromise = isProductFieldMigrationEnabled
    ? userEnrollmentContentInfoService.fetchQueryUserEnrollmentContentInfo(contentId)
    : enrollmentContentInfoPromise(queryClient, contentId)

  const [userContentDetails, userEnrollmentContentInfo] = await Promise.all([
    requestContentDetailsPromise,
    requestEnrollmentContentInfoPromise
  ])

  return {
    userContentDetails,
    userEnrollmentContentInfo
  }
}
